module.exports = __webpack_public_path__ + "static/media/MartialArts.9f227aee.svg";